import { useTranslation } from 'next-i18next';
import { useContext } from 'react';
import styled from 'styled-components';
import Modal from '../../../../../new-components/mobile/Modal';
import { SearchFiltersTypes } from '../../../../../reducers/search-filters/reducer';
import MinMaxInputContainer from '../../search-filters/min-max-view/MinMaxInputContainer';
import MultiSelectContainer from '../../search-filters/multi-select-view/MultiSelectContainer';
import SortByContainer from '../../search-filters/sort-by-input/SortByContainer';
import SliderContainer from '../../search-filters/slider-view/SliderContainer';
import MobileInnerModalFiltersView from './MobileInnerModalFiltersView';
import { ModalShowTypeState } from './MobileFilterBarPresentation';
import { useSelector } from 'react-redux';
import { isEqual } from '../../../../../helpers/isEqual';
import {
  SearchContext,
  SearchContextInterface
} from '../../../../search-new/context/SearchContext';
import { useRouter } from 'next/router';
import { useSorting } from '../../../../search-new/hooks/Sorting.hooks';

interface MobileModalProps {
  modalShowType: ModalShowTypeState;
  closeModal: () => void;
}
const MobileModalFiltersView = ({
  modalShowType,
  closeModal
}: MobileModalProps) => {
  const { t } = useTranslation('search');
  const { filterOptions, searchFiltersState, searchFiltersDispatch } =
    useContext(SearchContext) as SearchContextInterface;
  const { sorting } = useSorting();
  const searchBodyResults = useSelector(
    (state: any) => state.searchResults.searchResults,
    isEqual
  );

  return (
    <Container>
      <Modal
        isOpen={
          modalShowType.show && modalShowType.type == SearchFiltersTypes.SORT_BY
        }
        withCloseBtn={true}
        closeFn={closeModal}
      >
        {modalShowType.type == SearchFiltersTypes.SORT_BY && (
          <SortByContainer
            sortByOptions={sorting}
            searchFiltersState={searchFiltersState}
            searchFiltersDispatch={searchFiltersDispatch}
            isMobileCloseModal={closeModal}
            sortLocation="MobileFiltersBar"
          />
        )}
      </Modal>

      <Modal
        isOpen={
          modalShowType.show && modalShowType.type != SearchFiltersTypes.SORT_BY
        }
        withCloseBtn={false}
        closeFn={closeModal}
      >
        {modalShowType.type == SearchFiltersTypes.PROPERTY_TYPES && (
          <MobileInnerModalFiltersView
            filterName={t('property_types')}
            closeFn={closeModal}
          >
            <SliderContainer
              searchFiltersState={searchFiltersState}
              searchFiltersDispatch={searchFiltersDispatch}
              filterName={SearchFiltersTypes.PROPERTY_TYPES}
              filterTypes={filterOptions[SearchFiltersTypes.PROPERTY_TYPES]}
              options={searchBodyResults.loadedPropertyTypes}
              withCountDisplay={true}
              sliderLocation="MobileFiltersBar"
            />
          </MobileInnerModalFiltersView>
        )}
        {modalShowType.type == SearchFiltersTypes.BEDROOMS && (
          <MobileInnerModalFiltersView
            filterName={t('bedrooms')}
            closeFn={closeModal}
          >
            <MultiSelectContainer
              filterType={SearchFiltersTypes.BEDROOMS}
              maxDisplayedValue={5}
              shapeClass="circleShape"
            />
          </MobileInnerModalFiltersView>
        )}
        {modalShowType.type == SearchFiltersTypes.BATHROOMS && (
          <MobileInnerModalFiltersView
            filterName={t('bathrooms')}
            closeFn={closeModal}
          >
            <MultiSelectContainer
              filterType={SearchFiltersTypes.BATHROOMS}
              maxDisplayedValue={5}
              shapeClass="circleShape"
            />
          </MobileInnerModalFiltersView>
        )}
        {modalShowType.type == SearchFiltersTypes.MIN_PRICE && (
          <MobileInnerModalFiltersView
            filterName={`${t('price_range')} (${t('egp')})`}
            closeFn={closeModal}
          >
            <MinMaxInputContainer
              maxFilterType={SearchFiltersTypes.MAX_PRICE}
              minFilterType={SearchFiltersTypes.MIN_PRICE}
              minList={filterOptions.min_price}
              maxList={filterOptions.max_price}
              min={parseInt(filterOptions.min_price[0].value.toString())}
            />
          </MobileInnerModalFiltersView>
        )}
      </Modal>
    </Container>
  );
};

const Container = styled.div`
  /// will be removed later and make other view or made solution in presention
  .shape {
    background: ${props => props.theme.light.colors.lightGrey} !important;
    color: ${props => props.theme.light.colors.black} !important;
    border: 1px solid ${props => props.theme.light.colors.whitish} !important;
  }
  .selected {
    background: ${props => props.theme.light.colors.secondary} !important;
    color: ${props => props.theme.light.colors.white} !important;
    border: 1px solid ${props => props.theme.light.colors.secondary} !important;
  }

  .slider-item {
    border-radius: 7.5px;

    img {
      object-fit: unset;
    }
  }
`;
export default MobileModalFiltersView;
